const apiKey = "GCMUDiuY5a7WvyUNt9n3QztToSHzK7Uj";

export default apiKey;